module.exports = __webpack_public_path__ + "img/closed_outlet.1da13eb8.png";